import { withStyles } from '@mui/styles';
import DobInput from './dob-input';
import { styles } from './dob-input.styles';

export default withStyles(styles, { withTheme: true })(DobInput);
